#import "@/apollo/fragments/Job.gql"

mutation AddDownloadComputedDeliverablesJob(
    $campaignId: ID!
    $platform: DownloadPlatform!
    $computedDeliverableIdentifiers: [InputComputedDeliverableIdentifier]
    $libraryFilters: InputLibraryFilters
    $deviceScaleFactor: Int
    $platformOpts: InputDownloadJobPlatformOptions
) {
    addDownloadComputedDeliverablesJob(
        campaignId: $campaignId
        platform: $platform
        computedDeliverableIdentifiers: $computedDeliverableIdentifiers
        libraryFilters: $libraryFilters
        deviceScaleFactor: $deviceScaleFactor
        platformOpts: $platformOpts
    ) {
        ...Job
    }
}
